import type { ThemeState } from '@atlaskit/tokens/theme-config';

export const mobileAppTheme: Partial<ThemeState> = {
	colorMode: 'auto',
};
